module.exports = __webpack_public_path__ + "static/img/terminal-g++.a330dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/cpp/images/terminal-g++.png
// module id = vAYO
// module chunks = 1